// Action Types
export const FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_REQUEST = "FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_REQUEST";
export const FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_SUCCESS = "FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_SUCCESS";
export const FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_FAILURE = "FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_FAILURE";

// Action Creators
export const fetchGrowthOppurtunityByAccNclientRequest = (obj) => {
return (dispatch) => {
  dispatch({
    type: FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_REQUEST,
    payload: obj,
  });
};
};
export const fetchGrowthOppurtunityByAccNclientSuccess = (data) => ({
  type: FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_SUCCESS,
  payload: data,
});
export const fetchGrowthOppurtunityByAccNclientFailure = (error) => ({
  type: FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_FAILURE,
  payload: error,
});
